<template>
  <div  class="card_container" :style="{ zIndex: showFlip ? 4 : 0 }">
    <div
      @click="flipCard()"
      :class="[
        'four_widgets_box',
        data.front_widget_class,
        { 'flip-front': showFlip },
      ]"
      :style="`background-image: url('${data.bg_image}')`"
    >
      <div
        class="four_widgets_box-title"
        v-html="data.text"
      ></div>
      <img
        :class="['arrow_icon', data.arrow_class]"
        :src="data.arrow_icon_curved"
      />
    </div>

    <div
      @click="flipCard()"
      :class="[
        'four_widgets_box--show',
         data.back_widget_class,
        { 'flip-back': showFlip },
      ]"
    >
      <div class="show_content_wrapper">
        <div class="four_widgets_content">
          <div
            class="content_photo"
            :style="`background-image: url('${data.content_photo}')`"
          ></div>
          <div class="content_text">
            <div class="icon_and_title">
              <img class="" :src="data.content_icon" />
              {{ data.content_title }}
            </div>
            <p>
              {{ data.content_text }}
            </p>
          </div>
        </div>
        <img
           :class="['arrow_icon', data.arrow_class]"
          :src="data.arrow_icon_curved"
        />
      </div>
    </div>
  </div>

</template>

<script>
export default {
  props: ["component_data", "data", "index"],
  data() {
    return {
      showFlip: false,
      flipFront: false,
      flipBack: false,
   
    };
  },
  methods: {
    flipCard() {
      this.showFlip= !this.showFlip
    },
  },
  mounted() {
    this.$nextTick(() => {});
  },
};
</script>

<style lang="scss">
.card_container{
  backface-visibility: hidden;
}
.four_widgets_box,
.four_widgets_box--show {
  width: 100%;
  max-width: 780px;
  height: 20vw;
  max-height: 484px;
  background-color: #e41429;
  position: relative;
  background-position: center;
  background-size: contain;
  background-repeat: no-repeat;
  cursor: pointer;
  transition: all 1s ease;
  backface-visibility: hidden;
  @media screen and (max-width: 1400px) {
    height: 17vw;
    max-height: 307px;
  }
}
.four_widgets_box {
  padding: 31px 37px;
  @media screen and (max-width: 1400px) {
    padding: 10px 37px;
  }
}
.four_widgets_box--show {
  position: absolute;
  z-index: 2;
  transform: rotateY(-180deg);
  padding: 54px 37px;
  @media screen and (max-width: 1400px) {
    padding: 35px 17px 35px 37px;
  }

  &.back_first {
    left: 0;
    top: 0;
    border-radius: 30px 30px 0px 0px;
    margin-bottom: 66px;
  }
  &.back_second {
    right: 0;
    top: 0;
    border-radius: 30px 30px 0px 0px;
    margin-bottom: 66px;
  }
  &.back_third {
    left: 0;
    bottom: 0;
    border-radius: 0px 0px 30px 30px;
    padding-right: 7.5%;
  }
  &.back_fourth {
    right: 0;
    bottom: 0;
    border-radius: 0px 0px 30px 30px;
  }
}
.show_content_wrapper {
  display: flex;
  width: 100%;
  height: 100%;
}

.four_widgets_content {
  display: flex;
  width: 100%;
  height: 100%;
}
.content_photo {
  display: flex;
  width: 36%;
  height: 100%;
  overflow: hidden;
  background-position: center;
  background-size: contain;
  background-repeat: no-repeat;
  margin-right: 35px;
}
.content_text {
  display: flex;
  width: 60%;
  height: 100%;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  text-align: left;
  font-size: 1.56em;
  line-height: 1.56em;
  font-family: "Lato", sans-serif;
  color: white;
  p {
    max-width: 351px;
    @media screen and (max-width: 1600px) {
      max-width: 290px;
    }
  }
}
.icon_and_title {
  display: flex;
  width: 100%;
  justify-content: flex-start;
  align-items: center;
  font-size: 1.9em;
  margin-bottom: 17px;
  line-height: 150%;

  img {
    width: 5vw;
    margin-right: 11px;
  }
}

.four_widgets_box.front_first,
.four_widgets_box.front_second {
  border-radius: 30px 30px 0px 0px;
  margin-bottom: 66px;
  @media screen and (max-width: 1400px) {
    margin-bottom: 33px;
  }
}
.four_widgets_box.front_third,
.four_widgets_box.front_fourth {
  border-radius: 0px 0px 30px 30px;
}
.four_widgets_box.front_first,
.four_widgets_box.front_third {
  justify-content: flex-start;
}
.four_widgets_box.front_second,
.four_widgets_box.front_fourth {
  justify-content: flex-end;
  text-align: right;
}
.four_widgets_box-title {
  display: inline-flex;
  width: 70%;
  font-size: 3.7em;
  color: white;
  justify-content: flex-end;
  @media screen and (max-width: 1600px) {
    font-size: 3.2em;
  }
}
.arrow_icon {
  position: absolute;
  cursor: pointer;
  @media screen and (min-width: 1400px) {
    width: 25px;
  }
  &.first-box {
    top: 22px;
    right: 23px;
    @media screen and (max-width: 1400px) {
      top: 15px;
      right: 20px;
    }
  }
  &.second-box {
    top: 22px;
    left: 23px;
    @media screen and (max-width: 1400px) {
      top: 15px;
      left: 20px;
    }
  }
  &.third-box {
    bottom: 22px;
    right: 23px;
    @media screen and (max-width: 1400px) {
      bottom: 15px;
      right: 20px;
    }
  }
  &.fourth-box {
    bottom: 22px;
    left: 23px;
    @media screen and (max-width: 1400px) {
      bottom: 15px;
      left: 20px;
    }
  }
}
//animacja
.flip-front,
.flip-back {
  backface-visibility: hidden;
}
.flip-front {
  transform: rotateY(180deg);
}
.flip-back {
  transform: rotateY(0deg);
}
</style>
